var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DetailsCard,{attrs:{"staffingPosition":_vm.staffingPosition,"refetchQueries":_vm.refetchQueries}})
}
var staticRenderFns = []

export { render, staticRenderFns }